import { User, UserStar } from 'lucide-react'
import type { Member } from './schema'

// Status styles for Member type
export const statusStyles = new Map<Member['status'], string>([
  ['active', 'bg-teal-100/30 text-teal-900 dark:text-teal-200 border-teal-200'],
  ['invited', 'bg-sky-200/40 text-sky-900 dark:text-sky-100 border-sky-300'],
])

// Organization member roles (actual data)
export const roles = [
  {
    label: 'Org Admin',
    value: 'org_admin',
    icon: UserStar,
  },
  {
    label: 'Member',
    value: 'member',
    icon: User,
  },
] as const
